import { render, staticRenderFns } from "./UpdateProfileModal.vue?vue&type=template&id=013dfae8"
import script from "./UpdateProfileModal.vue?vue&type=script&lang=js"
export * from "./UpdateProfileModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateProfileModal.vue?vue&type=style&index=0&id=013dfae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports